import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/identityInfo/page', data, {
    trim: true
  })
}
export function allList (data) {
  return request.post('/business/identityInfo/memberList', data, {
    trim: true
  })
}

// 导出Excel
export function exportExcel (data) {
  return request.post('/business/identityInfo/exportExcel', data, {
    download: true
  })
}

// 创建
export function create (data) {
  return request.post('/business/identityInfo/create', data)
}
export function audit (data) {
  return request.post('/business/identityInfo/audit', data)
}

// 修改
export function updateById (data) {
  return request.post('/business/identityInfo/updateById', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/business/identityInfo/delete/${id}`)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/business/identityInfo/delete/batch', {
    params: {
      ids
    }
  })
}
